import axios from "axios";
import config from "./config";

export const smsMfa = (body) => {
  return axios.post("/sms-mfa", body, config);
}